export default [
  {
    label: 'Razão social',
    field: 'razaoSocial',
    editable: true,
    evento: null,
    tdClass: 'col-sticky col-sticky-1',
    thClass: 'col-sticky col-sticky-1 frente',
  },
  {
    label: 'CNPJ/CPF',
    field: 'cadastroFederal',
    tdClass: 'col-sticky col-sticky-2 col-nowrap col-tamanho-cnpj',
    thClass: 'col-sticky col-sticky-2 frente',
  },
  {
    label: 'Situação Geral',
    field: 'situacao',
    type: 'custom',
    tdClass: 'text-center',
    thType: 'custom-header',
    visible: true,
  },
  {
    label: 'Federal',
    field: 'federal',
    type: 'custom',
    tdClass: 'text-center',
    thType: 'custom-header',
    visible: false,
    grupo: 'federal',
  },
  {
    label: 'Situação Fiscal',
    field: 'situacaoFiscal',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela',
    visible: false,
    grupo: 'federal',
  },
  {
    label: 'DCTFWeb',
    field: 'dctfWeb',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-direita-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-direita-tabela',
    visible: false,
    grupo: 'federal',
  },
  {
    label: 'Certidões',
    field: 'certidoes',
    type: 'custom',
    tdClass: 'text-center',
    thType: 'custom-header',
    visible: false,
    grupo: 'certidoes',
  },
  {
    label: 'RFB/PGFN',
    field: 'cndRfbPgft',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela',
    visible: false,
    grupo: 'certidoes',
  },
  {
    label: 'FGTS',
    field: 'cndFgts',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela',
    visible: false,
    grupo: 'certidoes',
  },
  {
    label: 'Trabalhista',
    field: 'cndTrabalhista',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela',
    visible: false,
    grupo: 'certidoes',
  },
  // {
  //   label: 'MTE',
  //   field: 'cndMte',
  //   type: 'custom',
  //   tdClass: 'cor-secundaria-fundo-tabela text-center',
  //   thClass: 'cor-secundaria-fundo-tabela',
  //   visible: false,
  //   grupo: 'certidoes',
  // },
  {
    label: 'Estadual',
    field: 'cndEstadual',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela',
    visible: false,
    grupo: 'certidoes',
  },
  {
    label: 'Municipal',
    field: 'cndMunicipal',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-direita-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-direita-tabela',
    visible: false,
    grupo: 'certidoes',
  },
  {
    label: 'Parcelamentos',
    field: 'parcelamentos',
    type: 'custom',
    tdClass: 'text-center',
    thType: 'custom-header',
    visible: false,
    grupo: 'parcelamentos',
  },
  {
    label: 'Parcelamento SN',
    field: 'simplesNacional',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela',
    visible: false,
    grupo: 'parcelamentos',
  },
  {
    label: 'PERT-SN',
    field: 'pert',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    visible: false,
    thClass: 'cor-secundaria-fundo-tabela',
    grupo: 'parcelamentos',
  },
  {
    label: 'RELP-SN',
    field: 'relp',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela',
    visible: false,
    grupo: 'parcelamentos',
  },
  {
    label: 'RFB',
    field: 'rfb',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela',
    visible: false,
    grupo: 'parcelamentos',
  },
  {
    label: 'Não Previdenciário',
    field: 'naoPrevidenciario',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela',
    visible: false,
    grupo: 'parcelamentos',
  },
  {
    label: 'Simplificado Previdenciário',
    field: 'simplificadoPrevidenciario',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela',
    visible: false,
    grupo: 'parcelamentos',
  },
  {
    label: 'PGFN',
    field: 'pgfn',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-direita-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-direita-tabela',
    visible: false,
    grupo: 'parcelamentos',
  },
  {
    label: 'Simples Nacional',
    field: 'simplesNacionalInfo',
    type: 'custom',
    tdClass: 'text-center',
    thType: 'custom-header',
    visible: false,
    grupo: 'simplesNacionalInfo',
  },
  {
    label: 'Sublimite',
    field: 'sublimite',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-esquerda-tabela',
    visible: false,
    grupo: 'simplesNacionalInfo',
  },
  {
    label: 'DAS',
    field: 'das',
    type: 'custom',
    tdClass: 'cor-secundaria-fundo-tabela borda-direita-tabela text-center',
    thClass: 'cor-secundaria-fundo-tabela borda-direita-tabela',
    visible: false,
    grupo: 'simplesNacionalInfo',
  },
  {
    label: 'Ações',
    field: 'acoes',
    slot: 'acoes',
    tdClass: 'col-sticky-right col-td-acao-4 text-center',
    thClass: 'col-sticky-right col-td-acao-4 text-center',
    sortable: false,
    visible: true,
  },
]
